import React from 'react';

interface ISearchContext {
  search?: string;
  setSearch?: React.Dispatch<React.SetStateAction<string>>;
}

const SearchContext = React.createContext<ISearchContext>({});

export { SearchContext };
